/* eslint-disable import/prefer-default-export */
import { ubicationTypeEnum } from './dataStatus';

export const getUbicationLabel = (id) => {
  if (id === ubicationTypeEnum.pozo || id === ubicationTypeEnum.pozoOyM) return 'Ubicación pozo';
  if (id === ubicationTypeEnum.plantaAyP || id === ubicationTypeEnum.plantaGas)
    return 'Ubicación planta';
  if (id === ubicationTypeEnum.locacion) return 'Ubicación locación';
  if (id === ubicationTypeEnum.ducto) return 'Ubicación ducto';
  if (id === ubicationTypeEnum.edificio) return 'Ubicación edificio';
  if (id === ubicationTypeEnum.uspYBateria) return 'Ubicación USP y Batería';
  if (id === ubicationTypeEnum.almacen) return 'Ubicación almacén';
  if (id === ubicationTypeEnum.energia) return 'Ubicación energía';
  if (id === ubicationTypeEnum.talleresYBasesDeProveedores) return 'Ubicación taller';
  if (id === ubicationTypeEnum.locacionOYM) return 'Ubicación locación';
  if (id === ubicationTypeEnum.genericaOverhead || id === ubicationTypeEnum.genericaProyecto)
    return 'Ubicación genérica';

  return 'Ubicación';
};
